import DefaultEmpty from '../DefaultEmpty';
import DefaultLoadingSpinner from '../DefaultLoadingSpinner';

interface DefaultNotFoundContentProps {
  isLoading: boolean;
}

function DefaultNotFoundContent({ isLoading }: DefaultNotFoundContentProps) {
  return isLoading ? <DefaultLoadingSpinner /> : <DefaultEmpty />;
}

export default DefaultNotFoundContent;
